import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Flex } from 'react-flex'

import FbWrapper from '../../lib/FirebaseWrapper'
import NavigatorLoginButton from './NavigatorLoginButton'
import NavigatorResultChecker from './NavigatorResultChecker'
import NavigatorLiveTrading from './NavigatorLiveTrading'

class NavigationBar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      accountCheck: props.account
    }
  }

  _subscribe () {
    var re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    const subscriber = this.state.subscriber
    if (re.test(subscriber)) {
      FbWrapper.addSubscriber(subscriber, 'from navi-broadcast')
      this.msg.show('Subscription submitted!', {
        time: 2000,
        type: 'success'
      })
      this.setState({subscriber: ''})
    } else {
      this.msg.show('Invalid email address!', {
        time: 2000,
        type: 'error',
        icon: <img src='http://i.imgur.com/C7RBc0g.png' alt='error' style={{width: 32, height: 32}} />
      })
    }
  }

  _handleLogoClick () {
    this.props.history.push('/')
  }

  render () {
    return (
      <div className='navi' >
        <Flex row className='navi-wrapper' alignItems='center' justifyContent='space-between'>
          <div onClick={() => this._handleLogoClick()}>
            <img className='navi-logo' src='/logo.svg' alt='logo' />
          </div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <NavigatorResultChecker
              account={this.props.account}
              authUser={this.props.authUser}
              history={this.props.history} />
            <NavigatorLiveTrading
                history={this.props.history} />
            <NavigatorLoginButton
              authUser={this.props.authUser}
              history={this.props.history} />
          </div>
        </Flex>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
})

export default connect(mapStateToProps)(NavigationBar)



// WEBPACK FOOTER //
// ./src/components/NavigationBar/index.js